import Vue from 'vue';
import axios from 'axios';

const domain = `${process.env.VUE_APP_DOMAIN}/api/graphql`;

Vue.mixin({

  methods: {

    //抓搜尋區域
    CITYALL() {
      return axios.post(domain, {
        query: `
          query {
            parameterRoot {
              parameterList(parentId: "City", cultureName: "zh-TW") {
                pmId
                pmText
              }
            }
          }
          `,
      }).then(res => {
        return res
      });
    },

    //抓藏品
    COLLECTDATA(city , keyword) {
      return axios.post(domain, {
        query: `
        query {
          collectionRoot {
            collectionList(
              ageStart: 0
              ageEnd: 2300
              city: "${city}"
              beginNum: 1
              endNum: 1000
              sortField: "CId"
              keyword: "${keyword}"
            ) {
              totalCount
              items {
                rowNum
                cId
                collectionId
                name
                cityName
                address
                overview
                lon
                lat
                ageStart
                ageEnd
                focusPicId
                mediaUrlDesc
              }
            }
          }
        }
        
          `,
      }).then(res => {
        return res
      });
    },

    //抓藏品詳細
    COLLECTDATAINF(id) {
      return axios.post(domain, {
        query: `
        query {
          collectionRoot {
            collection(cId: ${id}) {
              rowNum
              cId
              collectionId
              name
              cityName
              address
              overview
              lon
              lat
              ageStart
              ageEnd
              focusPicId
              mediaUrlDesc
              pictureList(
                beginNum:1
                endNum:1
              ){
                items{
                  artPicId
                }
              }
            }
          }
        }
        
          `,
      }).then(res => {
        return res
      });
    },


  },



    

  
});

